import {
  FormControlLabel,
  FormGroup,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Title from "../../Components/Title";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import { getToken, getUser } from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";

const server = EnvSettings.server;

const removeTZOffset = (data) => {
  if (data === null || data === undefined || !data.includes(":")) {
    return null;
  }
  var ti = new Date().getTimezoneOffset();
  var mins = (parseInt(data.substr(0, 2)) * 60 + ti) / 60;
  mins = mins < 0 ? 24 + mins : mins > 23 ? mins - 24 : mins;
  mins =
    (mins.toString().length === 1 ? "0" + mins.toString() : mins.toString()) +
    ":00";
  return mins;
};

const addTZOffset = (data) => {
  if (data === null || data === undefined) {
    return null;
  }
  var ti = new Date().getTimezoneOffset();
  var mins = (parseInt(data.substr(0, 2)) * 60 - ti) / 60;
  mins = mins < 0 ? 24 + mins : mins > 23 ? mins - 24 : mins;
  mins =
    (mins.toString().length === 1 ? "0" + mins.toString() : mins.toString()) +
    ":00";
  return mins;
};

const getHours = () => {
  var arr = [];
  arr.push(null);
  for (let index = 0; index < 24; index++) {
    if (index.toString().length === 1) {
      arr.push(`0${index}:00`);
    } else {
      arr.push(`${index}:00`);
    }
  }
  return arr;
};

export default function CompanySettings() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [company, setCompany] = useState();
  const [hour, setHour] = useState();
  const [phoneNumber, setPhoneNumber] = useState(getUser().phoneNumber);
  const [smsAlerts, setSMSAlerts] = useState(getUser().smsAlerts);
  const dispatch = useDispatch();

  console.log(getUser());

  const getCompany = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_company", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setCompany(result.company);
          setHour(addTZOffset(result.company.dailyNotification));
        }
      });
  };

  const handleSubmit = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken(), company: company }),
    };
    fetch(server + "/edit_company", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        dispatch(showPopupSnackbar(result));
      });
  };

  const handleSMSSubmit = () => {
    // Check for + and length
    // +3580400611125
    if (
      !(
        phoneNumber &&
        phoneNumber[0] === "+" &&
        phoneNumber.length < 15 &&
        phoneNumber.length > 6 &&
        !isNaN(phoneNumber.substring(1, phoneNumber.length))
      )
    ) {
      alert(t("companySettings.phoneHelper"));
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        phoneNumber: phoneNumber,
        smsAlerts: smsAlerts,
      }),
    };
    fetch(server + "/set_sms_alerts", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        dispatch(showPopupSnackbar(result));
      });
  };

  useEffect(getCompany, []);

  return (
    <Paper className={classes.paper}>
      <Grid
        item
        container
        xs={12}
        direction="row"
        style={{ justifyContent: "space-between" }}
      >
        <Grid
          item
          container
          spacing={3}
          xs={6}
          justifyContent={"space-between"}
        >
          <Grid item xs={12}>
            <Title>{t("companySettings.setDailyNotification")}</Title>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              select
              value={hour ? hour : null}
              onChange={(e) => {
                setHour(e.target.value);
                setCompany({
                  ...company,
                  dailyNotification: removeTZOffset(e.target.value),
                });
              }}
              variant="outlined"
            >
              {getHours().map((option, index) => (
                <MenuItem key={option} value={option}>
                  {index === 0 ? t("companySettings.disabled") : option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" onClick={handleSubmit}>
              {t("companySettings.submit")}
            </Button>
          </Grid>
        </Grid>
        <Grid item container spacing={3} xs={6}>
          <Grid item xs={12} style={{ width: 200 }}>
            <Title>{t("companySettings.smsAlerts")}</Title>
            <Typography color="secondary">
              {t("companySettings.smsDescription")}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t("phoneNumber")}
              helperText={t("companySettings.phoneHelper")}
              defaultValue={phoneNumber}
              onChange={(e, v) => {
                setPhoneNumber(e.target.value);
              }}
            ></TextField>
          </Grid>
          <Grid item xs={6}>
            <FormGroup>
              <FormControlLabel
                checked={smsAlerts}
                control={<Switch color="secondary" />}
                label={t("companySettings.receiveSMS")}
                onChange={(e, v) => {
                  setSMSAlerts(v);
                }}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={12}>
            <Button variant="outlined" onClick={handleSMSSubmit}>
              {t("submit")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
